import { articlesQuery } from '~/statamic/queries/article';
import type { Articles } from '~/statamic/types/article';

type ArticlesOptions = {
  sort?: string;
  site?: string;
  page?: number;
  limit?: number;
  filter?: JSON;
  collection?: string;
};

export const useStatamicArticles = async (options: ArticlesOptions = {}): Promise<Articles> => {
  const { $statamic } = useNuxtApp();

  if (!options.site) {
    options.site = $statamic.site.handle;
  }

  const { data } = await useAsyncQuery<{articles: Articles}>(articlesQuery, {
    ...options,
    collection: 'articles',
  });
  const articles = data?.value?.entries;

  if (!articles) {
    throw new Error('Missing articles from Statamic.');
  }

  return articles;
};
